<template>
  <v-row justify="center">
    <v-col xl="10">
      <v-card>
        <v-card-title>
          <h2>{{ $t("admin.team.activities.title") }}</h2>
          <v-spacer></v-spacer>
          <v-text-field
            :label="$t('admin.team.activities.search')"
            append-icon="mdi-magnify"
            hide-details
            single-line
            v-model="search"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :no-data-text="$t('admin.team.activities.noData')"
          :options.sync="pagination"
          :server-items-length="totalItems"
          class="elevation-1"
          item-key="id"
        >
          <template v-slot:item.type="props">
            <v-tooltip v-if="props.item.type == 'WORKSHOP'" left>
              <template v-slot:activator="{ on }">
                <v-icon color="primary" v-on="on">mdi-briefcase</v-icon>
              </template>
              <span>{{ $t("admin.activities.list.workshop") }}</span>
            </v-tooltip>
            <v-tooltip v-else-if="props.item.type == 'EXTERNAL'" left>
              <template v-slot:activator="{ on }">
                <v-icon color="primary" v-on="on">mdi-open-in-new</v-icon>
              </template>
              <span>{{ $t("admin.activities.list.external") }}</span>
            </v-tooltip>
            <v-tooltip v-else-if="props.item.type == 'LIVE_STREAM'" left>
              <template v-slot:activator="{ on }">
                <v-icon color="primary" v-on="on">mdi-earth</v-icon>
              </template>
              <span>{{ $t("admin.activities.list.liveStream") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.date="props">
            {{ props.item.date | datetime }}
          </template>
          <template v-slot:item.duration="props">
            {{ props.item.duration | duration }}
          </template>

          <template v-slot:item.slug="props">
            <a v-bind:href="buildLink(props.item.slug)">{{ $t("admin.team.activities.landingPage") }}</a>
            <v-btn @click="copy(buildLink(props.item.slug))" class="mx-2" color="primary" dark icon raised x-small>
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <input id="link-copy" type="hidden" />
            <a v-bind:href="buildWallLink(props.item.slug)">{{ $t("admin.team.activities.wall") }}</a>
            <v-btn @click="copy(buildWallLink(props.item.slug))" class="mx-2" color="primary" dark icon raised x-small>
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import debounce from "../../../util/debounce";
import axios from "axios";

export default {
  data() {
    return {
      team: {},
      valid: false,
      totalItems: 0,
      items: [],
      loading: true,
      search: "",
      pagination: {
        itemsPerPage: 25,
      },
      headers: [
        { text: this.$t("admin.team.activities.name"), value: "name" },
        {
          text: this.$t("admin.team.activities.type"),
          value: "type",
          width: "80px",
        },
        { text: this.$t("admin.team.activities.date"), value: "date" },
        { text: this.$t("admin.team.activities.duration"), value: "duration" },
        {
          text: this.$t("admin.activities.list.link"),
          value: "slug",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      this.loading = true;
      this.team = await axios.get(`/event/teams/${this.$route.params.teamId}`);
      const result = await this.$axios.get(`/event/${this.team.id_event}/activities`, {
        params: {
          page: page - 1,
          size: itemsPerPage,
          sortBy: sortBy.join(","),
          sortOrder: sortDesc.map((s) => (s ? "desc" : "asc")).join(","),
          search: this.search || undefined,
        },
      });
      this.items = result.rows;
      this.totalItems = result.count;
      this.loading = false;
    },
    copy(link) {
      let linkCopySource = document.querySelector("#link-copy");
      linkCopySource.setAttribute("value", link);
      linkCopySource.setAttribute("type", "text");
      linkCopySource.select();
      document.execCommand("selectAll");
      if (document.execCommand("copy")) {
        this.$store.commit("SUCCESS", this.$t("admin.team.activities.copied"));
      }
      linkCopySource.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    buildLink(slug) {
      return `${window.location.origin}/online/${slug}/${this.team.slug}`;
    },
    buildWallLink(slug) {
      return `${window.location.origin}/wall/${slug}/${this.team.slug}`;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
    search: {
      handler() {
        debounce(this.loadData);
      },
      deep: true,
    },
  },
};
</script>
